import { useState, useMemo } from "react"
import { useLocation } from "react-router"
import { postSendRequestToken } from "../../myApiCenter"
import toast from "react-hot-toast"
import { useContext } from "react"
import { AuthContext } from "../../context/Can"
import { Input } from "reactstrap"

const parseTokensFromText = (text) => {
   try {
      const cleaned = text.trim()
      if (!cleaned) return null

      let paramString = ""

      const urlMatch = cleaned.match(/https?:\/\/[^\s]+/)
      if (urlMatch) {
         const questionMarkIndex = urlMatch[0].indexOf("?")
         if (questionMarkIndex !== -1) {
            paramString = urlMatch[0].substring(questionMarkIndex + 1)
         }
      }

      if (!paramString) {
         const paramMatch = cleaned.match(/auth_token=[^\s]+/)
         if (paramMatch) {
            paramString = paramMatch[0]
         }
      }

      if (!paramString) return { error: "No token parameters found in pasted text" }

      const params = new URLSearchParams(paramString)
      const authToken = params.get("auth_token")

      if (!authToken) return { error: "auth_token not found in pasted text" }

      return { authToken }
   } catch {
      return { error: "Could not parse the pasted text. Please paste the full URL." }
   }
}

const LogInWithKite = () => {
   const [userData] = useContext(AuthContext)
   const location = useLocation()
   const query = new URLSearchParams(location.search)

   const token = query.get("auth_token")

   const [apiKey, setapiKey] = useState(userData?.brokerDetail?.apiKey)
   const [manualUrl, setManualUrl] = useState("")

   const parsedResult = useMemo(() => parseTokensFromText(manualUrl), [manualUrl])

   const urlTokens = token ? { authToken: token } : null
   const finalTokens = urlTokens || (parsedResult && !parsedResult.error ? parsedResult : null)

   const submitHandler = async () => {
      if (!finalTokens) {
         toast.error("No valid token found")
         return
      }
      try {
         await postSendRequestToken({ authToken: finalTokens.authToken })
         toast.success("Token saved successfully")
      } catch (error) {
         console.log(error)
         toast.error("Failed to save token")
      }
   }

   return (
      <div className="login-with-kite-wrap">
         <h4>WELCOME TO ASTRALGO</h4>

         <div className="redirect-home w-50">
            <Input value={apiKey} onChange={(e) => setapiKey(e.target.value)} placeholder="Enter API Key" />
            <button
               onClick={() => {
                  if (apiKey) {
                     window.location.replace(
                        `https://smartapi.angelone.in/publisher-login?api_key=${apiKey}&state=statevariable`
                     )
                  } else {
                     toast.error("API key field should not be empty")
                  }
               }}
               className="my-kite-btn"
            >
               Redirect To Angel
            </button>
         </div>

         <div className="manual-token-wrap w-50 mt-2">
            <p className="mb-1">If not redirected, paste the full URL / error page text below:</p>
            <Input
               type="textarea"
               rows={5}
               value={manualUrl}
               onChange={(e) => setManualUrl(e.target.value)}
               placeholder="Paste the full URL or error page text containing tokens here..."
            />
            {manualUrl && parsedResult?.error && (
               <p style={{ color: "red", marginTop: 4, fontSize: 14 }}>{parsedResult.error}</p>
            )}
            {manualUrl && parsedResult && !parsedResult.error && (
               <p style={{ color: "green", marginTop: 4 }}>Token parsed successfully</p>
            )}
         </div>

         {finalTokens && (
            <button type="button" onClick={submitHandler} className="my-kite-btn mt-1">
               Save Token
            </button>
         )}
      </div>
   )
}

export default LogInWithKite